import { styled as s, ButtonBase as d } from "@mui/material";
import u from "../../hooks/useFetchSsoJson.js";
import h from "../../hooks/useSsoAuth.js";
import { SkeletonBox as f } from "../../../temp-lib/components/share/generic/Skeleton.js";
import x from "../../../temp-lib/components/share/next/Image.js";
import { SsoProviderType as t } from "../../../temp-lib/constants/account.js";
import * as i from "ramda";
import { useCallback as g } from "react";
import { jsx as e } from "react/jsx-runtime";
const S = s(f)`
  background-color: #0c0c0c;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  margin-bottom: 20px;
  padding: 12px 20px;
  position: relative;
  width: 100%;
`, b = s(d)`
  width: 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: white;
`, k = s(x)`
  width: 100%;
  height: 100%;
`, N = (n) => {
  const {
    className: a
  } = n, {
    login: c
  } = h(), {
    data: m
  } = u(), r = m || [], p = g(async (o) => {
    switch (o) {
      case t.APPLE:
      case t.DISCORD:
      case t.GOOGLE:
      case t.SKY_MAVIS:
        await c(o);
        break;
    }
  }, [c]), l = i.isNil(r) && i.isEmpty(r);
  return /* @__PURE__ */ e(S, {
    className: a,
    loading: l,
    children: i.map((o) => /* @__PURE__ */ e(b, {
      onClick: () => {
        p(o.type);
      },
      children: /* @__PURE__ */ e(k, {
        src: o.icon.circular
      })
    }, o.name), r)
  });
};
export {
  N as default
};
//# sourceMappingURL=CommunityAuthSection.js.map
